module.exports = __webpack_public_path__ + "static/media/silkycloud-2.a8556cf7.png";